import React, {Component, MouseEvent} from 'react';
import {RouteComponentProps, withRouter} from 'react-router';
import {ExpandIcon} from 'components/Icon';
import {AuthenticatedUser} from 'services/entities/auth';
import {logout} from 'services/auth';
import NextRouteURLs from 'NextRouteURLs';
import './index.scss';
import {getUserDefaultRoute} from "util/routing";
import {formatUserName} from "util/users";

interface UserWidgetState {
  menuOpen: boolean;
}

interface UserWidgetProps extends RouteComponentProps {
  user: AuthenticatedUser;
}

class UserWidget extends Component<UserWidgetProps, UserWidgetState> {
  state = {
    menuOpen: false
  };

  componentDidMount(): void {
    document.addEventListener('click', this.onDocumentClick);
  }

  componentWillUnmount(): void {
    document.removeEventListener('click', this.onDocumentClick);
  }

  onDocumentClick = () => {
    this.setState({menuOpen: false});
  };

  onDashboardClick = () => {
    this.props.history.push(getUserDefaultRoute(this.props.user));
  };

  onLogoutClick = () => {
    logout();
    if(this.props.history.location.pathname !== NextRouteURLs.HOME) {
      this.props.history.push(NextRouteURLs.HOME);
    } else {
      this.props.history.go(0);
    }
  };

  onAccountClick = (ev: MouseEvent) => {
    ev.stopPropagation();
    ev.nativeEvent.stopImmediatePropagation();
    this.setState({menuOpen: !this.state.menuOpen});
  };

  static getUserInitial(user: AuthenticatedUser): string {
    const name = user.firstName || user.username || user.email;
    return name ? name[0] : '';
  }

  static renderAvatar(user: AuthenticatedUser) {
    const avatarAccount = user.accounts.find(acc => acc.avatarURL);
    const avatarURL = avatarAccount ? avatarAccount.avatarURL : null;
    return <div className="avatar">
      { avatarURL && <img src={avatarURL} alt="Avatar" /> }
      { !avatarURL && <span>{ UserWidget.getUserInitial(user) }</span> }
    </div>;
  }

  render() {
    const user = this.props.user;
    const userName = formatUserName(user);
    return <span className="user-widget" onClick={this.onAccountClick}>
        { userName && <span className="name">Hello { userName }</span> }
        { UserWidget.renderAvatar(user) }
        <ExpandIcon />
        <ul className={this.state.menuOpen ? 'menu open' : 'menu'}>
          <li><button className="dashboard" onClick={this.onDashboardClick}>Dashboard</button></li>
          <li><button className="logout" onClick={this.onLogoutClick}>Log out</button></li>
          <li className="email">{ user.email }</li>
        </ul>
      </span>;
  }
}

export default withRouter(UserWidget);